import React from 'react';
import {StyledError, StyledForm, StyledFormLabel, StyledLabeledFieldContainer} from './styles';

export const FormGroup = ({children}) => {
    return (
        <StyledForm>
            {children}
        </StyledForm>
    );
};

export const FormLabel = ({label, isMandatory = false}) => {
    return (
        <StyledFormLabel>
            {label}
            {(isMandatory && <StyledError>*</StyledError>) || <></>}
        </StyledFormLabel>
    );
};

export const FormField = ({children, label, isMandatory = false}) => {
    return (
        <StyledLabeledFieldContainer>
            <FormLabel label={label} isMandatory={isMandatory}/>
            {children}
        </StyledLabeledFieldContainer>
    );
};

